<h2 mat-dialog-title>{{ 'OMNISEARCH.FIND_A_BUSINESS' | translate }}</h2>
<div class="searchbox">
  <mat-form-field floatLabel="never">
    <input
      matInput
      #searchTerm
      autocomplete="off"
      [placeholder]="'OMNISEARCH.SEARCH_BY_NAME_ADDRESS_OR_PHONE_NUMBER' | translate"
    />
  </mat-form-field>
</div>
<mat-dialog-content>
  <mat-nav-list>
    <a
      tabindex="0"
      mat-list-item
      *ngFor="let accountGroup of accountGroups$ | async"
      (click)="navigateToLocation(accountGroup.accountGroupId)"
      (keyup.enter)="navigateToLocation(accountGroup.accountGroupId)"
    >
      <app-address-cell matListItemTitle class="address" [accountGroup]="accountGroup"></app-address-cell>
      <span matListItemMeta class="account-icons">
        <app-omni-app-icon
          *ngFor="let account of accountGroup.accounts"
          [icons]="productIcons$ | async"
          [appId]="account.marketplaceAppId"
        ></app-omni-app-icon>
      </span>
    </a>
  </mat-nav-list>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>
    {{ 'COMMON.ACTION_LABELS.CLOSE' | translate }}
  </button>
</mat-dialog-actions>
